/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.control = {};
    Blockly.Blocks.control.style = 'control_blocks';
    Blockly.Blocks.control.style_init = 'control_blocks_init';
    Blockly.Blocks.control_arduino_loop = {
        helpUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.control.style_init);
            this.setPreviousStatement(!1);
            this.setNextStatement(!1);
            this.setDeletable(!1);
            this.setEditable(!1);
            this.setTooltip(Blockly.Msg.CONTROLS_ARDUINO_LOOP);
            this.appendDummyInput().appendField(Blockly.Msg.CONTROLS_ARDUINO_LOOP);
            this.appendStatementInput("DO").appendField("")
        }
    };
    Blockly.Blocks.control_group = {
        helpUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.control.style);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setDeletable(!0);
            this.setEditable(!0);
            this.setTooltip(Blockly.Msg.CONTROLS_GROUP);
            this.appendDummyInput().appendField(Blockly.Msg.CONTROLS_GROUP);
            this.appendStatementInput("DO").appendField("")
        }
    };
    Blockly.Blocks.control_arduino_setup = {
        helpUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.control.style_init);
            this.setPreviousStatement(!1);
            this.setNextStatement(!1);
            this.setDeletable(!1);
            this.setEditable(!1);
            this.setTooltip(Blockly.Msg.CONTROLS_ARDUINO_SETUP);
            this.appendDummyInput().appendField(Blockly.Msg.CONTROLS_ARDUINO_SETUP);
            this.appendStatementInput("DO").appendField("")
        }
    };
    Blockly.Blocks.controls_repeat_ext = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.CONTROLS_REPEAT_TITLE,
                args0: [{
                    type: "input_value",
                    name: "TIMES",
                    check: "Number"
                }],
                previousStatement: null,
                nextStatement: null,
                style: Blockly.Blocks.control.style,
                tooltip: Blockly.Msg.CONTROLS_REPEAT_TOOLTIP,
                helpUrl: ""
            });
            this.appendStatementInput("DO").appendField(Blockly.Msg.CONTROLS_REPEAT_INPUT_DO)
        }
    };
    Blockly.Blocks.controls_repeat = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.CONTROLS_REPEAT_TITLE,
                args0: [{
                    type: "field_input",
                    name: "TIMES",
                    text: "10"
                }],
                previousStatement: null,
                nextStatement: null,
                style: Blockly.Blocks.control.style,
                tooltip: Blockly.Msg.CONTROLS_REPEAT_TOOLTIP,
                helpUrl: ""
            });
            this.appendStatementInput("DO").appendField(Blockly.Msg.CONTROLS_REPEAT_INPUT_DO);
            this.getField("TIMES").setChangeHandler(Blockly.FieldTextInput.nonnegativeIntegerValidator)
        }
    };
    Blockly.Blocks.controls_whileUntil = {
        init: function() {
            var a = [
                [Blockly.Msg.CONTROLS_WHILEUNTIL_OPERATOR_WHILE, "WHILE"],
                [Blockly.Msg.CONTROLS_WHILEUNTIL_OPERATOR_UNTIL, "UNTIL"]
            ];
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.control.style);
            this.appendValueInput("BOOL").setCheck("Boolean").appendField(new Blockly.FieldDropdown(a), "MODE");
            this.appendStatementInput("DO").appendField(Blockly.Msg.CONTROLS_WHILEUNTIL_INPUT_DO);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            var b = this;
            this.setTooltip(function() {
                var c = b.getFieldValue("MODE");
                return {
                    WHILE: Blockly.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_WHILE,
                    UNTIL: Blockly.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL
                }[c]
            })
        }
    };
    Blockly.defineBlocksWithJsonArray([  // BEGIN JSON EXTRACT
        // Block for 'for' loop.
        {
          "type": "controls_for",
          "message0": "%{BKY_CONTROLS_FOR_TITLE}",
          "args0": [
            {
              "type": "field_variable",
              "name": "VAR",
              "variable": null,
              "variableTypes": ["Number"],    // Specifies what types to put in the dropdown
              "defaultType": "Number"
            },
            {
              "type": "input_value",
              "name": "FROM",
              "check": "Number",
              "align": "RIGHT"
            },
            {
              "type": "input_value",
              "name": "TO",
              "check": "Number",
              "align": "RIGHT"
            },
            {
              "type": "input_value",
              "name": "BY",
              "check": "Number",
              "align": "RIGHT"
            }
          ],
          "message1": "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
          "args1": [{
            "type": "input_statement",
            "name": "DO"
          }],
          "inputsInline": true,
          "previousStatement": null,
          "nextStatement": null,
          "style": Blockly.Blocks.control.style,
          "helpUrl": "",
          "extensions": [
            "contextMenu_newGetVariableBlock",
            "controls_for_tooltip"
          ]
        },
      ]);  // END JSON EXTRACT (Do not delete this comment.)

/**
 * Mixin to add a context menu item to create a 'variables_get' block.
 * Used by blocks 'controls_for' and 'controls_forEach'.
 * @mixin
 * @augments Blockly.Block
 * @package
 * @readonly
 */
 Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN = {
    /**
     * Add context menu option to create getter block for the loop's variable.
     * (customContextMenu support limited to web BlockSvg.)
     * @param {!Array} options List of menu options to add to.
     * @this {Blockly.Block}
     */
    customContextMenu: function(options) {
      if (this.isInFlyout) {
        return;
      }
      var variable = this.getField('VAR')
                         .getVariable();
      var varName = variable.name;

      if (!this.isCollapsed() && varName != null) {
        var option = {enabled: true};
        option.text =
            Blockly.Msg['VARIABLES_SET_CREATE_GET'].replace('%1', varName);
        var xmlField = Blockly.Variables.generateVariableFieldDom(variable);
        var xmlBlock = Blockly.utils.xml.createElement('block');
        xmlBlock.setAttribute('type', 'variables_get_number');
        xmlBlock.appendChild(xmlField);
        option.callback = Blockly.ContextMenu.callbackFactory(this, xmlBlock);
        options.push(option);
      }
    }
  };

      Blockly.Extensions.unregister('contextMenu_newGetVariableBlock');
      Blockly.Extensions.registerMixin('contextMenu_newGetVariableBlock',
      Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN);

      Blockly.Extensions.unregister('controls_for_tooltip');
      Blockly.Extensions.register('controls_for_tooltip',
      Blockly.Extensions.buildTooltipWithFieldText(
          '%{BKY_CONTROLS_FOR_TOOLTIP}', 'VAR'));

    Blockly.Blocks.control_wait_whileUntil = {
        init: function() {
            var a = [
                [Blockly.Msg.TIME_WAIT_UNTIL, "UNTIL"],
                [Blockly.Msg.TIME_WAIT_WHILE, "WHILE"]
            ];
            this.setStyle(Blockly.Blocks.control.style);
            this.appendValueInput("CONDITION").setCheck("Boolean").appendField(new Blockly.FieldDropdown(a), "MODE");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0)
        }
    };
}

